import {AUTH} from 'src/shared/auth/actions';
import {locationsSuggestions} from 'src/shared/config/urls';
import {LOAD_USER_COMPLETE} from 'src/shared/user/actions';
import {createFetchResourceAction} from 'src/shared/utils/resource';

export const LOAD_LOCATION_SUGGESTIONS_START = 'LOAD_LOCATION_SUGGESTIONS_START';
export const LOAD_LOCATION_SUGGESTIONS_SUCCESS = 'LOAD_LOCATION_SUGGESTIONS_SUCCESS';
export const LOAD_LOCATION_SUGGESTIONS_ERROR = 'LOAD_LOCATION_SUGGESTIONS_ERROR';
export const LOAD_LOCATION_SUGGESTIONS_COMPLETE = 'LOAD_LOCATION_SUGGESTIONS_COMPLETE';
export const CLEAR_LOCATION_SUGGESTIONS = 'CLEAR_LOCATION_SUGGESTIONS';

import {accessToken} from 'src/pages/deviceInfo/store/selectors/deviceInfo';

export const locationSuggestionsUrl = query => state =>
  locationsSuggestions(state, query ? {streetAddress: query} : {});

export const loadLocationSuggestions = query => createFetchResourceAction({
  start: LOAD_LOCATION_SUGGESTIONS_START,
  success: LOAD_LOCATION_SUGGESTIONS_SUCCESS,
  error: LOAD_LOCATION_SUGGESTIONS_ERROR,
  complete: LOAD_LOCATION_SUGGESTIONS_COMPLETE,
  waitUntil: [AUTH, LOAD_USER_COMPLETE],
  url: locationSuggestionsUrl(query),
  token: accessToken,
  fetchOptions: {headers: {
    'Content-Type': 'application/json',
  }},
});

export const clearLocationSuggestions = () => ({type: CLEAR_LOCATION_SUGGESTIONS});
